<div [formGroup]="formGroup">
  <h2 mat-dialog-title>{{ translations.title }}</h2>
  <mat-dialog-content>
    <app-input
      formControlName="internalReferenceNumber"
      [label]="translations.internalReferenceNumber"
    ></app-input>
    <app-input
      formControlName="ddsIdentifier"
      [label]="translations.ddsIdentifier"
      [tooltip]="translations.ddsIdentifierTooltip"
    ></app-input>
    <div class="font-size-14" i18n="@@delivery-overlay.addexistingdds.note">
      <b>Note:</b>
      this will not get the product / production place(s) information of this DDS from TRACES, as
      their integration does not support providing this info. This will simply add a reference of
      that DDS to your delivery.
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <app-button-group>
      <app-button (pressed)="onClose()" type="ghost" i18n="@@shared.cancel">Cancel</app-button>
      <app-button (pressed)="onSubmit()" i18n="@@shared.confirm">Confirm</app-button>
    </app-button-group>
  </mat-dialog-actions>
</div>
